<template>
  <v-app class="transparent-imp">
    <v-container v-if="fid">
      <v-form ref="form" lazy-validation v-on:submit.prevent>
        <v-text-field
          v-model="card"
          id="cardinp"
          :label="$t('card')"
          :placeholder="$t('phCard')"
          prepend-inner-icon="mdi-credit-card-outline"
          :disabled="loading"
          flat
          outlined
          shaped
          dense
          :counter="counter"
          :error-messages="error"
          :loading="loading"
          append-icon="mdi-magnify"
          @keyup.escape="card=''"
          @keyup.enter="getCard"
          @click:append="getCard"
          :rules="[v=>/^\d+$/gi.test(v) ||$t('errors.digits'),v=>!counter||v.length==counter||$t('errors.length')]"
        ></v-text-field>
      </v-form>
      <v-sheet class="mt-n2 transparent-imp">
        <v-row v-if="response.debit || response.debit==0">
          <v-col cols="12" class="text-center f-tt-container">
            <span :data-title="$t('tt.debit')" class="f-tooltip f-debit">
              <v-icon class="mr-4" color="yellow">mdi-gold</v-icon>
              <span class="resp-val">{{format('currency', response.debit)}}</span>
            </span>
          </v-col>
        </v-row>
        <v-row v-if="response.burn || response.burn==0" class="mb-2">
          <v-col cols="12" class="h-valid">{{$t('burn')}}</v-col>
          <v-col cols="12" class="v-valid">
            <v-icon class="mr-4" color="red">mdi-fire</v-icon>
            {{format("currency",response.burn)}}
          </v-col>
        </v-row>
        <v-row v-if="response.amount_discount || response.amount_discount==0">
          <v-col cols="8" class="f-tt-container">
            <span class="f-tooltip f-amtd" :data-title="$t('tt.amt_disc')">
              <v-icon class="mr-4" color="blue">mdi-cart-plus</v-icon>
              <span class="resp-val">{{format('currency', response.amount_discount)}}</span>
            </span>
          </v-col>
          <v-col cols="4" class="text-right f-tt-container">
            <span class="f-tooltip f-disc" :data-title="$t('tt.discount')">
              <v-icon class="mr-4" color="green">mdi-sale</v-icon>
              <span class="resp-val">{{format('percent', response.current_discount)}}</span>
            </span>
          </v-col>
        </v-row>
        <v-row v-if="response.valid" :class="isNotValid">
          <v-col cols="12" class="h-valid">{{$t('valid')}}</v-col>
          <v-col cols="12" class="v-valid">{{format('valid',response.valid)}}</v-col>
        </v-row>
      </v-sheet>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment";
const params = new URLSearchParams(window.location.search);
const API =
  process.env.NODE_ENV === "production"
    ? "https://api.e-kartes.lv/WebManager/v20/frame"
    : "https://192.168.112.114/WebManager/v20/frame";
export default {
  name: "App",

  data: () => ({
    card: "",
    counter: false,
    response: {},
    loading: false,
    error: "",
    fid:""
  }),
  computed: {
    isNotValid() {
      return this.response.valid && moment().isAfter(this.response.valid)
        ? "red--text"
        : "";
    },
    nextMonth() {
      moment.locale(this.$i18n.locale);
      return moment()
        .add(1, "month")
        .startOf("month")
        .format("DD/MMM/YYYY");
    }
  },
  watch: {
    card: {
      handler(c) {
        if (!c) {
          this.clear();
        }
      }
    }
  },
  created() {
    try {
      this.$i18n.locale = params.get("l").toLowerCase();
    } catch (e) {
      this.$i18n.locale = "lv";
    }
    try {
      this.counter = params.get("cl");
    } catch (e) {
      this.counter = false;
    }
    try {
      this.fid = params.get("f");
    } catch (e) {
      this.fid = false;
    }
  },
  methods: {
    clear() {
      this.error = "";
      this.response = {};
    },
    format(key, val) {
      if (key == "currency") return this.currency(val);
      if (key == "percent") return val + "%";
      if (key == "valid") {
        moment.locale(this.$i18n.locale);
        return moment(val).format("DD/MMM/YYYY");
      }
      return val;
    },
    getCard() {
      if (!this.$refs.form.validate()) return;
      this.clear();
      if (this.loading) return;
      this.loading = true;
      this.axios
        .post(API, {
          f: this.fid,
          c: this.card
        })
        .then(response => {
          this.loading = false;
          if (response.data.data) {
            if (response.data.data.status != 100)
              this.error = this.$t("errors.block");
            this.response = { ...response.data.data };
          } else if (response.data.error) {
            this.error = this.$t("errors." + response.data.error);
          }
        })
        .catch(e => {
          if (e.response) this.error = this.$t("errors." + e.response.status);
          this.loading = false;
        });
    },
    currency(val) {
      let v = parseInt(val);
      if (isNaN(v)) return "";
      let nStr = (v / 100).toString();
      let x = nStr.split(".");
      let x1 = x[0];
      let x2 = x.length > 1 ? "." + x[1] + (x[1].length == 1 ? "0" : "") : "";
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + " " + "$2");
      }
      return x1 + x2 + " €";
    }
  }
};
</script>
<style scoped>
.transparent-imp {
  background: transparent !important;
}
.f-tt-container {
  position: relative;
}
.resp-header {
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: small;
}
.resp-val {
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 700;
}
.h-valid {
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: small;
  text-align: center;
}
.v-valid {
  padding-top: 0px;
  padding-bottom: 0px;
  font-weight: 700;
  text-align: center;
}
.v-last_used {
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: small !important;
  font-weight: normal !important;
}
.f-tooltip:hover::after {
  content: attr(data-title);
  position: absolute; /* Абсолютное позиционирование */
  z-index: 1; /* Отображаем подсказку поверх других элементов */
  background: rgba(255, 255, 230, 0.9); /* Полупрозрачный цвет фона */
  color: black;
  font-family: Arial, sans-serif; /* Гарнитура шрифта */
  font-size: 20px; /* Размер текста подсказки */
  font-weight: normal;
  font-style: normal;
  padding: 5px 10px; /* Поля */
  border: 1px solid #333; /* Параметры рамки */
  border-radius: 4px;
  text-align: center;
}
.f-tooltip.f-debit:hover::after {
  left: 40px;
  top: 32px;
}
.f-tooltip.f-disc:hover::after {
  left: -110px;
  top: 32px;
}
.f-tooltip.f-amtd:hover::after {
  left: 40px;
  top: 32px;
}
</style>
